<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import SingleRowView from '../../components/GenericView/SingleRowView.svelte';
	import { actionInterpretator } from '../../helpers/scene_actions_to_ui';
	import type { DeviceActionUI } from '../../../../types/DeviceActionUI';
	import type { NotificationActionUI } from '../../../../types/NotificationActionUI';
	import type { SceneActionUI } from '../../../../types/SceneActionUI';
	import { extract_actions_variables } from './extract_actions_variables';
	import type { GroupActionUI } from '../../../../types/GroupActionUI';
	import { getElseSceneAction, getSceneActionPurpose } from '../../helpers/get_delayed_scene_action';

	import { Label, Stack } from '@Shelly/shelly-design-system';

	export let element;

	const dispatch = createEventDispatcher();

	const elseAction = getElseSceneAction(element);
	let msg_type = element.msg_type;
	let purpose = getSceneActionPurpose(element, elseAction);

	let display_modal = false;

	if (elseAction !== undefined) {
		//if there is else => it is a delay action, stupid, but in other way we miss it
		element = { ...elseAction, delay: element.wait, units: element.units };
	}
	let translated: NotificationActionUI | DeviceActionUI | SceneActionUI | GroupActionUI | undefined =
		actionInterpretator(purpose, element, msg_type);

	const { title, subtitle, labelList, withLabelList, avatar, description, actionList } =
		extract_actions_variables(translated);

	const handle_click = () => {
		display_modal = true;
	};
</script>

<SingleRowView
	{withLabelList}
	{labelList}
	{avatar}
	{title}
	{subtitle}
	{description}
	withEdit={false}
	on:click={() => {
		dispatch('edit-else');
	}}
	on:open_detailed={() => handle_click()}
/>

{#if actionList && actionList.length > 0}
	<Stack gap="s" class="mt-s">
		{#each actionList as { icon, name }}
			<Label class="width-full justify-content-start" {icon} value={name} size="s" />
		{/each}
	</Stack>
{/if}
